<p-fieldset [legend]="field.label" [toggleable]="true" [collapsed]="field.options.collapsed">
  <!-- Build and Render -->
  <div style="margin: 5px;">
    <div *ngIf="assetRecord">
          <div style="margin-bottom: 1%;">
            <h5 class="p-d-inline p-mr-2">Render Asset? <i pTooltip="Renders the asset once it has been successfully built, and a slack notification is sent to preview the asset." class="pi pi-info-circle" style="font-size: 12px"></i></h5>
          </div>
            <p-inputSwitch class="p-d-inline" [(ngModel)]="field.options.buildAndRender"></p-inputSwitch>

            <div class="p-grid" >
              <div class="p-col-12">
                <strong>{{field.label}} Name:</strong>
                <span
                  *ngIf="assetRecord?.name || assetRecord?.id"
                  class="copyable-text"
                  pTooltip="Click to copy: Name, ID, filename"
                  tooltipPosition="top"
                  (click)="copyAssetInfo()"
                >{{assetRecord ? assetRecord.name : ''}}
                  <a href="/miscellaneous-build/{{assetRecord ?  assetRecord.id : ''}}" target="_blank" [ngStyle]="{ color: 'var(--primary-color)' }" (click)="$event.stopPropagation()"
                  >({{assetRecord ?  assetRecord.id : ''}})</a>
                </span>
                <ng-container *ngIf="!(assetRecord?.name || assetRecord?.id)">{{assetRecord ? assetRecord.name : ''}}
                  <a href="/miscellaneous-build/{{assetRecord ?  assetRecord.id : ''}}" target="_blank" [ngStyle]="{ color: 'var(--primary-color)' }">({{assetRecord ?  assetRecord.id : ''}})</a>
                </ng-container>
              </div>
              <div class="p-col-12">
                <strong>{{field.label}} Path:</strong>
                <span
                  *ngIf="assetRecord?.path"
                  class="copyable-text"
                  pTooltip="Click to copy path"
                  tooltipPosition="top"
                  (click)="copyPath()"
                >{{assetRecord.path}}</span>
                <ng-container *ngIf="!assetRecord?.path">{{assetRecord ? assetRecord.path : ''}}</ng-container>
              </div>
              <div class="p-col-12">
                <strong>{{field.label}} Asset Type:</strong>  {{assetRecord && assetRecord.assetType !== null && assetRecord.assetType !== undefined ? getAssetType(assetRecord.assetType): ''}}
              </div>
              <div class="p-col-12 p-my-3 p-d-flex" >
                <build-asset
                  class="p-ml-1"
                  [entity]="assetRecord"
                  [path]="assetRecord.path"
                  [type]="'miscellaneous-build'"
                  (triggerCompleteEvent)="getUpdatedBuildData($event)"
                  label="Build Asset"
                  [renderAsset]="field.options.buildAndRender"
                  [buildType]="payloadBuildType"
                ></build-asset>
                <build-asset
                  class="p-ml-3 p-mr-5"
                  [entity]="assetRecord"
                  [path]="assetRecord.path"
                  [type]="'miscellaneous-build'"
                  (triggerCompleteEvent)="getUpdatedBuildData($event)"
                  label="Build Asset as High Priority"
                  [buildType]="payloadBuildType"
                  [renderAsset]="field.options.buildAndRender"
                  [isHighPriority]="true"
                ></build-asset>
                  <p-button
                  label="See Latest Builds History"
                  target="_blank"
                  (click)="openInNewTab(getDynamicURL(assetRecord.id))"
                ></p-button>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-6">
                <span>
                  <strong>Created By:</strong>
                  {{ getBuildEntity()?.createdBy?.name || record?.createdBy?.name || getBuildEntity()?.userData?.name || record?.userData?.name || '' }}
                </span>
                <br>
                <span>
                  <strong>Created At:</strong>
                  {{ getBuildEntity()?.createdAt ? (getBuildEntity()?.createdAt | date:'medium') : (record?.createdAt ? (record?.createdAt | date:'medium') : (getBuildEntity()?.userData?.timestamp ? (getBuildEntity()?.userData.timestamp | date:'medium') : (record?.userData?.timestamp ? (record?.userData.timestamp | date:'medium') : ''))) }}
                </span>
                <br>
                <span>
                  <strong>Updated At:</strong>
                  {{ getBuildEntity()?.updatedAt ? (getBuildEntity()?.updatedAt | date:'medium') : (record?.updatedAt ? (record?.updatedAt | date:'medium') : '') }}
                </span>
              </div>
              <div class="p-col-6">
                <span>
                  <strong>Promotional Status:</strong>
                </span>
                <br>
                <span>
                  <strong>Asset Promoted Status:</strong>
                  {{ assetRecord ? isUptoDate(assetRecord)  : '' }}
                </span>
                <br>
                <hash-compare-display
                  [currentHash]="getLastVersionHash(assetRecord)"
                  [lastHash]="assetRecord.lastHash"
                  [promotedAt]="getPromotedAtFromVersions(getVersions(assetRecord), assetRecord.lastHash)">
                </hash-compare-display>
              </div>
              <div class="p-col-12">
              </div>
              <div class="p-col-6">
                <span>
                  <strong>Promotional Status:</strong>
                </span>
                <br>
              </div>
            </div>
            <div>
              <p-accordion [multiple]="true">
                <p-accordionTab header="Asset Build Data" [selected]="true">
                  <build-data
                    [entity]="assetRecord"
                    [type]="'miscellaneous-build'"
                    [buildData]="assetRecord.buildData"
                    [buildType]="assetRecord.entityType"
                    (triggerRefreshEvent)="getUpdatedBuildData()"
                    [assetType]="assetRecord.assetType"
                  ></build-data>
                </p-accordionTab>
              </p-accordion>
            </div>
        </div>
      </div>
</p-fieldset>

